import axiosClient from '../axiosClient';

const voucherAPI = {
    async getListVoucherAPI(params) {
        const url = `/voucher`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getOneVoucherAPI(id, params) {
        const url = `/voucher/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default voucherAPI;
